import './login.scss';
import tpl from './login.html';
import { LoginActions } from 'core/services/login';
import configFile from 'config.json';


export let LoginComponent = {
  templateUrl: tpl,
  selector: 'login',
  bindings: {
    translations: '='
  },
  controllerAs: 'vm',
  controller: LoginCtrl
};

export const translationKeys = [];

LoginCtrl.$inject = ['$ngRedux', 'ngNotify', '$state', 'localStorageService', '$scope'];

function LoginCtrl($ngRedux, ngNotify, $state, localStorageService, $scope) {
  Object.assign(this, { $ngRedux, ngNotify, $state, localStorageService, $scope });
  this.doLogin = doLogin.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.version = configFile.version;
  let unsubscribe;
  this.$onDestroy = () => {
    this.loginReset();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, LoginActions)(this);
    this.loginReset();
  };

  /**
   * Metodo que autentica el user con el backend
   */
  function doLogin() {
    if ($scope.loginForm.$invalid) {
      this.submitted = true;
      this.ngNotify.set(this.translations['Debe ingresar su nombre de usuario y contraseña'], 'error');
      return;
    }
    this.login(this.username, this.password);
  }

  function mapStateToThis(state) {

    if (state.login.loginError) {
      this.ngNotify.set(state.login.loginError.message, 'error');
    } else if (state.login.accessToken && state.login.accessToken.token) {
      let today = new Date();
      localStorageService.set('sessionInitDate', today.getDate());
      this.$state.go('home.landing');
    }

    return {
      login: state.login
    };
  }
}


// WEBPACK FOOTER //
// ./src/components/login/login.component.js